/**
 * 관리자 알림 모아보기 (/adm/tasks)
 * ($j.Pages.Admin.Tasks / body data-page-name="Tasks")
 *
 * 흩어진 관리자 알림을 건단위로 모아보고 **그 자리에서 처리한다.** 축은 셋이고 무게가 다르다 —
 * 종류(맨 위 탭) · 담당(전체 · 내 이름 · 미배정) · 상태(전체 · 할 일 · 완료 · 제외). 담당·상태는
 * 세그먼트라 **한 축에서 하나만** 고른다 — 실제로 쓰는 조합은 「신규+처리중」(= 할 일) 하나였다.
 *
 * **종류 탭은 하나만 고른다.** 「전체」는 종류가 섞인 공용 목록(제목 한 줄)이고, 한 종류를
 * 고르면 그 종류 전용 칸으로 바뀐다(Tasks/Views.js) — 처리 화면에 가지 않고 목록에서 판단하게.
 * 여럿을 섞어 고르면 전용 칸을 그릴 수 없어서 단일 선택이다.
 *
 * **줄을 누르면 그 건의 처리창이 뜬다**(`BadgeSource::HANDLER` — 부정발주·악덕·탈퇴·환원보류).
 * 담당 화면으로 보내지 않는다. 처리창이 소스를 바꾸면 원장은 그 결과를 따라 닫힌다(자동완료).
 * 줄 끝 ⋯ 는 원장 쪽 손잡이(이력·목록에서 빼기·다시 열기)다.
 *
 * '완료' 버튼은 없다. 소스가 열려 있는데 원장만 닫으면 다음 동기화가 도로 열기 때문이다.
 */
import Views from './Tasks/Views';

export default class Tasks {

    /** 처리 상태 표기 — 표·이력이 같은 말을 쓴다 */
    /**
     * 처리 상태 — 코드와 화면말. **상태 칩이 이 표 그대로 선다.**
     *
     * 화면의 축은 셋이고 자리가 다르다. **탭은 누구의 일인가**(전체·내 이름·미배정),
     * **상태 칩은 어떤 상태인가**, **종류 칩은 어느 종류인가**. 한때 완료·제외가 탭에
     * 섞여 있었는데, 그러면 「내 일 + 완료」 같은 조합이 갈 곳을 잃는다.
     */
    static STATE_LABEL = { new: '신규', doing: '처리중', done: '완료', skip: '제외' };

    /**
     * 담당 축 — 「전체」는 합이 아니다(남이 맡은 것이 있다). 그래서 수를 서버가 따로 센다.
     * mine 칸은 로그인한 관리자 이름으로 부른다 — 표의 담당 칸에 찍히는 말과 같다. 'My' 는 이름이 없을 때만
     */
    static SCOPE_LABEL = { mine: 'My', unassigned: '미배정' };

    /**
     * 상태 세그먼트 — 칸 하나가 상태 묶음 하나다. 「신규」는 「할 일」의 곁가지로 작게 붙는다 —
     * 종(배지)이 부정발주를 `state=new` 로 열고, 아무도 안 본 건만 볼 일이 실제로 있다.
     * 여기 없는 조합(주소로 온 `state=doing` 등)은 어느 칸도 켜지지 않은 채 그대로 거른다.
     */
    static STATE_PICK = { open: ['new', 'doing'], new: ['new'], done: ['done'], skip: ['skip'], '': [] };

    /** 관리자 팔레트의 색이름 (_tokens.scss 의 $adm-hues + slate) */
    static HUES = ['red', 'orange', 'amber', 'yellow', 'green', 'blue',
                   'indigo', 'violet', 'rose', 'sky', 'slate'];


    initialize() {
        // 빈 배열이 「전체」다. 담당·상태는 **여러 개를 고를 수 있고**(한 축 안 OR, 축끼리 AND —
        // 「신규·처리중」 + 「악덕」 = 아직 안 끝난 악덕), 종류는 **하나만** 고른다(목록 모양이 바뀐다).
        // 범위를 넓히는 값은 없다: 「전체」가 이미 내가 볼 수 있는 전부(우리 부서 + 내가
        // 맡은 것)이고, 칩은 좁히기만 한다
        // 첫 화면은 **아직 안 끝난 것**만 — 신규 + 처리중. 이 화면을 여는 이유가 그것이고,
        // 완료 수십 건이 섞여 있으면 할 일이 그만큼 묻힌다. 「전체」를 누르면 닫힌 것까지 나온다
        this.picked = { scope: [], state: ['new', 'doing'], type: [] };
        this.f      = {};   // 종류 전용 목록의 검색조건 (Tasks/Views.js 의 filters)
        this.$table = null;
        this.me     = parseInt($('#tkRoot').data('me'), 10) || 0;
        this.myName = String($('#tkRoot').data('my-name') || '');

        this.applyUrlType();
        this.swapAxes('', this.view());
        this.applyViewState('', this.view());
        this.applyUrlState();
        this.resetFilters(true);
        this.syncKwd();
        this.fillDateLabel();
        this.initDatePicker();
        // 회원 팝오버 — 표를 다시 만들어도 살아있게 안 바뀌는 바깥 상자에 건다
        $j.F.Admin.Member.Pop.bind('#tkRoot');
        this.drawChips();   // 수가 오기 전에도 자리는 서 있어야 한다 (목록이 오면 수만 채워진다)
        this.initTable();
        this.bindFilters();
        this.bindActions();
        this.openFromQuery();
    }

    destroy() {
        if (this.$table) { this.$table.destroy(); this.$table = null; }
        $('#tkRoot').off('.tk').off('click.mbpop');
        $(document).off('click.tkact');
        $(document).off('.tk');
        $(window).off('.tk');
    }

    /** 배지·다른 화면이 `?type=devil` 로 종류를 지정해 들어온다. 종류는 하나만 고른다(첫 값) */
    applyUrlType() {
        const t = (new URLSearchParams(location.search).get('type') || '').split(',')[0];
        this.picked.type = t ? [t] : [];
    }

    /**
     * 종이 상태를 지정해 들어온다 — `?type=collusion&state=new`. 처음 들어올 때만 먹는다.
     * 종류를 고르며 비워진(swapAxes) 상태 칩 위에 얹는다. 모르는 값은 버린다
     */
    applyUrlState() {
        const s = (new URLSearchParams(location.search).get('state') || '').split(',')
            .filter((v) => Tasks.STATE_LABEL[v]);
        if (s.length) this.picked.state = s;
    }

    /** 지금 보는 종류 전용 칸 — 종류 하나를 골랐고 그 모양이 정해져 있을 때만 */
    view() {
        const t = this.picked.type[0] || '';
        return t && Views[t] ? t : '';
    }

    /**
     * 종류 전용 목록의 검색조건을 기본값으로 — 종류를 바꿀 때마다.
     * 처음 들어올 때만 주소의 같은 이름 값을 얹는다 (`?type=collusion&cs_type=reorder&ring=12`) —
     * 다른 화면(제재관리 현황의 무리)이 조건을 지정해 보낸다.
     */
    resetFilters(fromUrl = false) {
        const v  = this.view();
        const qs = new URLSearchParams(location.search);
        this.f = {};
        if (!v) return;

        for (const x of Views[v].filters || []) {
            this.f[x.key] = x.def !== undefined ? String(x.def) : '';
            if (fromUrl && qs.has(x.key)) this.f[x.key] = qs.get(x.key) || '';
        }
    }

    /**
     * 종류 전용 조건을 그린다 — 필터는 **최대 세 줄**이다(담당 · 상태 · 이 줄). 칩·셀렉트·주소로 온 조건은
     * 셋째 줄에 일자로 서고, 첫 칩은 줄머리 자리에 서서 「전체」가 위 두 줄과 나란하다.
     * 글칸·도구는 오른쪽 찾는 자리에 붙는다.
     *
     * 담당·상태는 종류 전용 목록에서도 그대로 쓴다 — 서버가 원장에서 맞는 건만 골라 소스를
     * 좁힌다(AdminTaskQueryService::source). 기간만은 원장 발생일·처리일을 보는 손잡이라
     * 소스 목록에 맞지 않아 접는다 — 같은 일은 조건이 한다.
     */
    drawFilters() {
        const v = this.view();
        $('#tkPeriod, #tkDateLab').prop('hidden', !!v);
        $('#tkRange').prop('hidden', !!v || $('#tkPeriod').val() !== 'custom');

        const kwd  = this.kwdFilter();
        const rest = v ? (Views[v].filters || []).filter((x) => x !== kwd) : [];
        const esc  = (t) => this.esc(t);
        const opts = (x) => (typeof x.options === 'function' ? x.options() : (x.options || []));

        const seg = (x) => `<div class="tk-seg">${opts(x).map(([k, l]) =>
            `<button type="button"${String(k) === (this.f[x.key] ?? '') ? ' class="is-on"' : ''}
                     data-tk-f="${x.key}" data-tk-fv="${esc(k)}">${esc(l)}</button>`).join('')}</div>`;
        const segs = rest.filter((x) => x.type === 'seg').map((x, i) => (i === 0
            ? `<span class="tk-row__l">${esc(x.label || '')}</span>${seg(x)}`
            : `<span class="tk-row__g"><span class="tk-srcf__l">${esc(x.label || '')}</span>${seg(x)}</span>`)).join('');

        $('#tkSrcTexts').html(rest.filter((x) => x.type === 'text').map((x) =>
            `<input type="text" class="form-control form-control-sm" data-tk-f="${x.key}"
                    value="${esc(this.f[x.key] ?? '')}" placeholder="${esc(x.placeholder || '')}"
                    style="width:${x.width || 160}px" autocomplete="off">`).join(''));

        const extras = rest.map((x) => {
            const val = this.f[x.key] ?? '';
            if (x.type === 'select') {
                return `<label class="tk-srcf__l">${esc(x.label || '')}
                    <select class="form-control form-control-sm" data-tk-f="${x.key}">${opts(x).map(([k, l]) =>
                        `<option value="${esc(k)}"${String(k) === val ? ' selected' : ''}>${esc(l)}</option>`).join('')}
                    </select></label>`;
            }
            if (x.type === 'hidden' && val) {
                return `<button type="button" class="tk-chip is-on" data-tk-fclear="${x.key}" title="조건 풀기">
                            ${esc(x.label ? x.label(val) : val)} <i class="fas fa-xmark"></i></button>`;
            }
            return '';
        }).join('');

        $('#tkSrcRows').html(segs || extras
            ? `<div class="tk-row tk-row--src">${segs}<span class="tk-srcf tk-row__g">${extras}</span></div>` : '');

        $('#tkSrcTools').html((v ? Views[v].tools || [] : []).map((t, i) =>
            `<button type="button" class="btn btn-sm btn-outline-secondary" data-tk-tool="${i}">
                ${t.icon ? `<i class="fas ${t.icon}"></i> ` : ''}${esc(t.label)}</button>`).join(''));
    }

    /** 조건줄의 글칸 값을 모은다 — 검색을 누를 때(엔터 포함). 위 검색칸이 맡은 조건도 함께 */
    readTextFilters() {
        $('#tkRoot input[data-tk-f]').each((i, el) => { this.f[$(el).data('tk-f')] = $(el).val().trim(); });
        const k = this.kwdFilter();
        if (k) this.f[k.key] = ($('#tkKwd').val() || '').trim();
    }

    /**
     * 검색칸이 맡는 조건 — 종류 목록이면 그 종류의 **첫 글칸**. 찾는 자리를 하나로 두려는 것이다
     * (예전엔 상세검색과 조건줄 글칸 두 군데였고, 종류를 고르면 상세검색이 잠겼다).
     */
    kwdFilter() {
        const v = this.view();
        return v ? (Views[v].filters || []).find((x) => x.type === 'text') || null : null;
    }

    /** 검색칸을 지금 목록에 맞춘다 — 값·안내문구. 종류가 바뀔 때마다 */
    syncKwd() {
        const v = this.view();
        const k = this.kwdFilter();
        $('#tkKwd').val(k ? (this.f[k.key] || '') : '')
            .attr('placeholder', k ? (k.placeholder || '검색') : '원장번호 · 이름 · 사유 · 오더번호')
            .prop('disabled', !!v && !k);
        $('#tkSearch').prop('disabled', !!v && !k);
    }

    /** 검색 — 검색칸·조건줄 글칸 둘 다 여기로 */
    search() {
        if (this.view()) this.readTextFilters();
        this.reload();
    }

    /**
     * 주소로 지목된 한 건을 연다 — `?type=devil&open=5372`. 알림(itemUrl)·옛 주소 리다이렉트가 여기로 온다.
     * 값은 한 번만 먹는다(TaskOpen.take — 새로고침에 처리창이 되살아나지 않게).
     */
    openFromQuery() {
        const ref = $j.F.Admin.TaskOpen.take();
        const t   = this.picked.type[0] || '';
        const handler = ($('#tkRoot').data('handlers') || {})[t];
        if (ref && handler) this.handleInPlace({ handler, ref_id: ref, num: 0, type: t });
    }

    /**
     * 담당·상태 칩을 「전체」 목록과 종류 전용 목록이 **따로 기억한다.**
     *
     * 「전체」 목록의 기본(신규·처리중)을 종류 목록에 그대로 들고 가면 알림에 안 오른 건이 다
     * 빠져 소스 전체를 보러 온 뜻이 없어진다. 그래서 종류로 들어갈 때 비우고(=전체), 「전체」로
     * 돌아오면 전에 고른 값을 되살린다. 종류끼리 옮길 때는 고른 값을 그대로 들고 간다.
     */
    swapAxes(was, now) {
        if (!!was === !!now) return;
        const cur = { scope: this.picked.scope, state: this.picked.state };
        const kept = this._axes || { scope: [], state: now ? [] : ['new', 'doing'] };
        this.picked.scope = kept.scope;
        this.picked.state = kept.state;
        this._axes = cur;
    }

    /**
     * 종류가 첫 화면의 상태 칩을 정해뒀으면(`defaultState`) 들어올 때 그 값으로 맞춘다.
     * 그 종류를 떠나 다른 종류로 갈 때는 비운다 — 안 비우면 옆 종류까지 좁혀진 채로 넘어간다.
     */
    applyViewState(was, now) {
        if (was === now) return;
        const def = now ? Views[now].defaultState : null;
        if (def) this.picked.state = [...def];
        else if (now && was && Views[was].defaultState) this.picked.state = [];
    }

    /** 서버로 보낼 값 — 고른 것이 없으면 빈 문자열(=그 축 전부) */
    pickedStr(axis) {
        return this.picked[axis].join(',');
    }

    /**
     * 상단 세 축을 그린다 — 종류 탭 · 담당 · 상태.
     *
     * 고르기 전에 **어디에 몇 건 있는지** 보여야 무엇부터 볼지 정할 수 있다. 수는 **그 축을 뺀
     * 나머지 조건**으로 세므로(서버 `list`), 한 종류를 고른 상태에서도 다른 종류의 수가 그대로
     * 보인다 — 0 이면 갈 곳이 없다는 것도 정보다.
     */
    drawChips(res) {
        // 세 축을 한 덩이로 들고 있는다 — 하나라도 빠뜨리면 그 줄만 0 으로 그려진다
        if (res) {
            const prev = this._counts || {};
            this._counts = { scopes: res.scopes || prev.scopes || {}, states: res.states || prev.states || {},
                             types: res.types || {} };
            if (!this._order) this._order = this.tabOrder(this._counts.types);
        }
        const c = this._counts;

        // 종류 전용 목록이면 수는 **그 종류의 원장**에서 센 것이다. 담당·상태의 「전체」에는 수를
        // 얹지 않는다 — 그때 목록은 소스 전체(알림에 안 오른 건 포함)라 원장 수와 맞지 않는다
        const src = !!this.view();
        this.drawScope(c ? c.scopes || {} : null, src);
        this.drawState(c ? c.states || {} : null, src);
        this.drawTabs(c ? c.types || {} : null);
    }

    /** 세그먼트 한 칸. n 이 null 이면 수를 얹지 않는다(아직 안 왔거나 셀 수 없는 칸) */
    segBtn(axis, val, label, n, on, cls = '') {
        return `<button type="button" class="${cls}${on ? ' is-on' : ''}" data-tk-axis="${axis}" data-tk-val="${val}">`
             + `${this.esc(label)}${n === null || n === undefined ? '' : `<em>${n}</em>`}</button>`;
    }

    /** 담당 — 「전체」는 합이 아니라서(남이 맡은 것이 있다) 서버가 센 값을 쓴다 */
    drawScope(c, src) {
        const on = this.picked.scope[0] || '';
        const n  = (k) => (c ? c[k] || 0 : null);
        $('#tkScopeChips').html(
            this.segBtn('scope', '', '전체', src || !c ? null : c.all || 0, on === '')
            + Object.keys(Tasks.SCOPE_LABEL).map((k) => this.segBtn('scope', k, (k === 'mine' && this.myName) || Tasks.SCOPE_LABEL[k], n(k), on === k)).join(''));
    }

    /** 상태 — 전체 · 할 일(+신규) · 완료 · 제외 */
    drawState(c, src) {
        const key = this.stateKey();
        const n   = (...ks) => (c ? ks.reduce((s, k) => s + (c[k] || 0), 0) : null);
        $('#tkStateChips').html(
              this.segBtn('state', '',     '전체', src ? null : n('new', 'doing', 'done', 'skip'), key === '')
            + this.segBtn('state', 'open', '할 일', n('new', 'doing'), key === 'open')
            + this.segBtn('state', 'new',  '신규', n('new'), key === 'new', 'tk-seg__sub')
            + this.segBtn('state', 'done', '완료', n('done'), key === 'done')
            + this.segBtn('state', 'skip', '제외', n('skip'), key === 'skip'));
    }

    /** 지금 고른 상태가 어느 칸인가 — 맞는 칸이 없으면 null (주소로 온 다른 조합) */
    stateKey() {
        const cur = [...this.picked.state].sort().join(',');
        return Object.keys(Tasks.STATE_PICK).find((k) => [...Tasks.STATE_PICK[k]].sort().join(',') === cur) ?? null;
    }

    /**
     * 탭 순서 — **화면을 열 때 한 번** 열린 건이 많은 순으로 정하고 그 뒤로는 움직이지 않는다.
     * 조건을 바꿀 때마다 줄을 다시 세우면 손이 기억한 자리에 탭이 없다. 같은 수면 등록 순서(ODR)
     */
    tabOrder(counts) {
        const keys = Object.keys($('#tkChips').data('labels') || {});
        return keys.map((k, i) => [k, i]).sort((a, b) => ((counts[b[0]] || 0) - (counts[a[0]] || 0)) || (a[1] - b[1]))
                   .map(([k]) => k);
    }

    /** 종류 탭 — 색 점은 목록의 종류 뱃지와 같은 색이다(Provider 의 HUE 가 정본) */
    drawTabs(c) {
        const labels = $('#tkChips').data('labels') || {};
        const hues   = $('#tkChips').data('hues') || {};
        const keys   = this._order || Object.keys(labels);
        const on     = this.picked.type[0] || '';
        const n      = (k) => (c ? c[k] || 0 : null);
        // 폴더 라인의 색 — 고른 종류의 색. 「전체」는 종류색이 없어 기본색(_tasks.scss)
        $('#tkRoot .tk-head').attr('data-hue', on ? this.hue(hues[on]) : '');
        const tab = (k, label, cnt) => `
            <button type="button" class="tk-tab${on === k ? ' is-on' : ''}${cnt === 0 ? ' is-zero' : ''}"
                    data-tk-axis="type" data-tk-val="${k}">
                ${k ? `<i class="tk-dot tk-dot--${this.hue(hues[k])}"></i>` : ''}${this.esc(label)}${cnt === null ? '' : `<em>${cnt}</em>`}
            </button>`;

        $('#tkChips').html(
            '<span class="tk-row__l">종류</span>'
            + tab('', '전체', c ? keys.reduce((s, k) => s + n(k), 0) : null)
            + keys.map((k) => tab(k, labels[k], n(k))).join('')
            + '<button type="button" class="tk-tab tk-tab--more" id="tkMore" hidden>더보기 <i class="fas fa-caret-down"></i></button>');
        this.fitTabs();
    }

    /**
     * 탭이 넘치면 뒤에서부터 「더보기」로 접는다 — 가로 한 줄을 지킨다(종류는 계속 는다).
     * 고른 탭은 접지 않는다. 뒤일수록 수가 적은 종류다(tabOrder).
     */
    fitTabs() {
        const bar = $('#tkChips')[0];
        if (!bar) return;
        const $more = $('#tkMore');
        const tabs  = $(bar).find('.tk-tab[data-tk-val]').not('[data-tk-val=""]').prop('hidden', false).toArray();
        $more.prop('hidden', true);
        this._folded = [];
        if (bar.scrollWidth <= bar.clientWidth) return;

        $more.prop('hidden', false);
        for (const el of tabs.reverse()) {
            if (bar.scrollWidth <= bar.clientWidth) break;
            if (el.classList.contains('is-on')) continue;
            el.hidden = true;
            this._folded.unshift(el.dataset.tkVal);
        }
    }

    /** 「더보기」 — 접힌 탭을 판톤 메뉴로 편다 */
    openMore(anchor) {
        const labels = $('#tkChips').data('labels') || {};
        const hues   = $('#tkChips').data('hues') || {};
        const c      = (this._counts || {}).types || {};
        const rows   = (this._folded || []).map((k) =>
            `<div class="jb-menu__i" data-tk-axis="type" data-tk-val="${k}">`
            + `<span><i class="tk-dot tk-dot--${this.hue(hues[k])}"></i>${this.esc(labels[k])}</span><em>${c[k] || 0}</em></div>`).join('');
        $j.Ui.Tooltip.show(anchor, `<div class="jb-menu tk-moremenu">${rows}</div>`, { tone: 'panel' });
    }

    /**
     * 축 하나를 고른다 — 탭·세그먼트·「더보기」 메뉴가 같은 문으로 들어온다.
     * 상태·종류를 바꾸면 **컬럼이 갈리므로**(담당 ↔ 처리자 / 공용 ↔ 종류 전용) 표를 새로 세우고,
     * 담당만 바꾸면 다시 받기만 한다. 종류 전용 목록은 칸이 담당·상태와 무관하다
     */
    pick(axis, v) {
        if (axis === 'type') {
            if ((this.picked.type[0] || '') === v) return;
            const was = this.view();
            this.picked.type = v ? [v] : [];
            this.swapAxes(was, this.view());
            this.applyViewState(was, this.view());
            this.resetFilters();
            this.syncKwd();
        } else if (axis === 'state') {
            if (this.stateKey() === v) return;
            this.picked.state = [...(Tasks.STATE_PICK[v] || [])];
            this.fillDateLabel();
        } else {
            if ((this.picked.scope[0] || '') === v) return;
            this.picked.scope = v ? [v] : [];
        }

        this.drawChips();   // 누른 즉시 칠해진다(응답을 기다리지 않는다)
        if (axis === 'type' || (axis === 'state' && !this.view())) { this.initTable(); return; }
        this.reload();
    }

    /**
     * 첫 화면은 **전체기간**이다 — 기간칸을 비워 둔다.
     *
     * 한때 최근 3개월을 기본으로 채웠는데, 그러면 그보다 오래 방치된 미처리 건이 첫 화면에서
     * 빠진다. **놓치면 안 되는 것이 정확히 그런 건**이라, 기본은 전부 보여주고 좁히는 것은
     * 사람이 상세검색에서 하게 둔다. 일감 수가 많지 않아 전체를 훑어도 비용이 같다.
     */
    ymd(d) {
        const p = (n) => String(n).padStart(2, '0');
        return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
    }

    /**
     * 기간 달력 — 관리자 공용 mobiscroll (접수목록과 같은 설정).
     *
     * 데스크톱에만 붙인다. 모바일에서는 피커가 화면을 다 덮어 표를 못 보므로 손입력으로 둔다.
     * 인풋이 `type="text"` 인 이유가 이것이다 — `type="date"` 면 브라우저 기본 달력과
     * mobiscroll 이 겹쳐 뜬다.
     */
    initDatePicker() {
        const reload = () => this.reload();

        if (!$j.Common.Util.isMobile()) {
            $('#tkFrom, #tkTo').mobiscroll().datepicker({
                controls: ['calendar'],
                dateFormat: 'YYYY-MM-DD',
                locale: mobiscroll.localeKo,
                buttons: [],            // 설정/확인 버튼 없이 고르면 바로 반영
                onChange: reload,
            });
        } else {
            $('#tkFrom, #tkTo').removeAttr('readonly').attr('placeholder', 'YYYY-MM-DD');
        }

        $('#tkPeriod').on('change.tk', () => this.applyPeriod());
    }

    /**
     * 기간 드롭다운 — 자주 쓰는 구간은 고르기만 하면 끝난다. 「직접 지정」일 때만 달력칸이 뜨고,
     * 그때는 달력에서 날짜를 고를 때 다시 받는다(지금 칸의 값이 출발점이다)
     */
    applyPeriod() {
        const p = $('#tkPeriod').val();
        $('#tkRange').prop('hidden', p !== 'custom');
        if (p === 'custom') return;

        const days = { today: 1, 7: 7, 30: 30 }[p];
        if (days) {
            const to = new Date(), from = new Date();
            from.setDate(to.getDate() - (days - 1));
            $('#tkFrom').val(this.ymd(from));
            $('#tkTo').val(this.ymd(to));
        } else {
            $('#tkFrom, #tkTo').val('');
        }
        this.reload();
    }

    /**
     * 탭에 맞춰 기간의 뜻을 적는다.
     *
     * 열린 탭은 '언제 들어왔나'(발생), 완료 탭은 '언제 처리했나'(처리)를 묻는 자리다.
     * 같은 칸이 뜻만 바뀌므로 **라벨로 말해준다** — 말없이 기준이 바뀌면 결과를 못 믿는다.
     */
    fillDateLabel() {
        $('#tkDateLab').text(Tasks.isClosed(this.state()) ? '처리' : '발생');
    }

    /**
     * 닫힌 것을 보고 있나 — 서버의 같은 판정과 짝이다(`AdminTaskQueryService::isClosed`).
     * **탭이 아니라 고른 상태가 정한다.** 완료를 고르면 어느 탭에서든 처리자 컬럼이 서고
     * 정렬·기간축이 처리일로 바뀐다.
     */
    static isClosed(states) {
        // **고른 것이 전부 닫힌 상태일 때만** 닫힘 모드다 (서버 판정과 짝) —
        // 「신규 + 완료」처럼 섞어 고르면 열린 것이 함께 있으므로 '발생' 기준이 맞다
        return !!states.length && states.every((s) => s === 'done' || s === 'skip');
    }

    /** 지금 고른 상태들 */
    state() {
        return this.picked.state;
    }

    bindFilters() {
        $('#tkHelp').on('click.tk', (e) => this.showHelp(e.currentTarget));

        $('#tkSearch').on('click.tk', () => this.search());
        $('#tkFrom, #tkTo').on('change.tk', () => this.reload());
        $('#tkKwd').on('keydown.tk', (e) => {
            if (e.key === 'Enter') { e.preventDefault(); this.search(); }
        });

        $('#tkRoot').on('click.tk', '[data-tk-axis]', (e) => {
            const $b = $(e.currentTarget);
            this.pick($b.data('tk-axis') + '', $b.data('tk-val') + '');
        });
        // 「더보기」 메뉴는 body 밑에 뜬다 — 문서에 건다
        $('#tkRoot').on('click.tk', '#tkMore', (e) => this.openMore(e.currentTarget));
        $(document).on('click.tk', '.tk-moremenu [data-tk-axis]', (e) => {
            $j.Ui.Tooltip.hide();
            this.pick('type', $(e.currentTarget).data('tk-val') + '');
        });
        // 창 폭이 바뀌면 탭을 다시 접는다
        let fitT = 0;
        $(window).on('resize.tk', () => { clearTimeout(fitT); fitT = setTimeout(() => this.fitTabs(), 120); });

        // ── 종류 전용 목록의 조건줄 ──
        // 칩·셀렉트는 고르는 즉시, 글칸은 엔터·검색으로. 칸 모양을 바꾸는 조건(columns)이면 표를 새로 세운다
        const changed = (key) => {
            const def = (Views[this.view()].filters || []).find((x) => x.key === key) || {};
            this.drawFilters();
            if (def.columns) this.initTable(); else this.reload();
        };
        $('#tkRoot').on('click.tk', '[data-tk-fv]', (e) => {
            const $b = $(e.currentTarget);
            const key = $b.data('tk-f') + '';
            if (this.f[key] === $b.data('tk-fv') + '') return;
            this.readTextFilters();
            this.f[key] = $b.data('tk-fv') + '';
            changed(key);
        });
        $('#tkRoot').on('change.tk', 'select[data-tk-f]', (e) => {
            this.readTextFilters();
            this.f[$(e.currentTarget).data('tk-f')] = $(e.currentTarget).val();
            this.reload();
        });
        $('#tkRoot').on('keydown.tk', 'input[data-tk-f]', (e) => {
            if (e.key !== 'Enter') return;
            e.preventDefault();
            this.search();
        });
        $('#tkRoot').on('click.tk', '[data-tk-fclear]', (e) => {
            this.readTextFilters();
            this.f[$(e.currentTarget).data('tk-fclear')] = '';
            changed($(e.currentTarget).data('tk-fclear') + '');
        });
        $('#tkRoot').on('click.tk', '[data-tk-tool]', (e) => {
            const t = (Views[this.view()].tools || [])[$(e.currentTarget).data('tk-tool')];
            if (t) t.run(this);
        });
    }

    /**
     * 상단 요약 카드는 두지 않는다 — **같은 수를 두 자리에 두지 않기 위해서다.**
     * 담당 축은 탭이, 종류별 수는 칩이, 지연은 목록의 「경과」칸이 빨갛게 말한다.
     * 카드로 한 번 더 세면 한쪽만 갱신되는 순간 거짓이 된다.
     */
    reload() {
        if (this.$table) this.$table.ajax.reload(null, false);
    }

    /**
     * 이 화면 사용법 — 물음표 팝오버.
     *
     * 안내문을 화면에 줄로 늘어놓으면 늘 같은 말이라 며칠이면 아무도 안 읽고, 그러면서
     * 자리는 계속 먹는다. 접어두고 **필요할 때 펴는** 것이 맞다.
     *
     * 적는 것은 **화면을 봐도 모르는 것**뿐이다 — 무엇이 저절로 되는지(완료), 되돌릴 수
     * 있는지(제외), 남의 일을 열면 어떻게 되는지. 칩이 무엇을 거르는지·무엇이 보이는지처럼
     * 눌러보면 아는 것은 적지 않는다. 설명이 길어질수록 정작 읽어야 할 줄이 묻힌다.
     */
    showHelp(anchor) {
        $j.Ui.Tooltip.show(anchor, `
            <div class="tk-help-doc">
                <p><b>흩어진 관리자 알림을 한곳에서 보고 처리한다.</b>
                   종류 탭을 하나 고르면 그 종류의 <b>전체 목록</b>(알림에 안 오른 건까지)과 검색조건으로 바뀐다.
                   여기서 담당·상태를 고르면 <b>알림에 오른 건 중</b> 그 조건인 것만 남는다.</p>

                <dl>
                    <dt>처리하는 길</dt>
                    <dd>줄을 누르면 그 자리에서 <b>처리창</b>이 뜬다(맡을지 한 번 묻는다).
                        담당 화면으로 옮겨가지 않는다.</dd>

                    <dt>완료는 저절로</dt>
                    <dd>처리창에서 그 일을 끝내면 원장이 따라 닫힌다. <b>완료 버튼은 없다</b> —
                        일이 안 끝났는데 여기서만 닫으면 다음 동기화가 도로 연다.</dd>

                    <dt>목록에서 빼기</dt>
                    <dd>줄 끝 <b>⋯</b> 에 있다. 처리하지 않고 내리는 유일한 길 —
                        상태 <b>제외</b>에 남고 거기서 다시 열 수 있다.</dd>

                    <dt>담당이 겹칠 때</dt>
                    <dd>남이 맡고 있는 건을 열면 물어본다. 이어서 처리하면 담당이 나로 바뀐다.</dd>
                </dl>
            </div>`,
            // 기본톤(메모지 연노랑) 그대로 둔다 — 도움말은 '적어둔 쪽지' 지 조작판이 아니다.
            // 판톤(흰 바탕)은 고르는 목록에 쓴다(처리 메뉴)
            { maxWidth: 560 });
    }

    /* ── 목록 ───────────────────────────────────────── */

    initTable() {
        if (this.$table) { this.$table.destroy(); $('#tkTable').empty().html('<thead><tr></tr></thead><tbody></tbody>'); }

        const self = this;
        const view = this.view();
        this.drawFilters();
        this.$table = new DataTable('#tkTable', {
            autoWidth: false,
            processing: true, serverSide: true, ordering: false,
            pageLength: 20, lengthChange: false, searching: false,
            ajax: {
                // 종류 하나 = 그 종류의 소스 전체(source), 아니면 원장(list)
                url: view ? '/adm/ajax/tasks/source' : '/adm/ajax/tasks/list', type: 'post',
                // 목록을 받을 때마다 칩의 수도 같이 온다 — 따로 조회하지 않는다
                dataSrc: (json) => { self.drawChips(json); return json.data; },
                data: (d) => {
                    if (view) {
                        d.type = view;
                        d.f    = Object.assign({}, self.f,
                                               { scope: self.pickedStr('scope'), state: self.pickedStr('state') });
                        return;
                    }
                    d.scope   = self.pickedStr('scope');
                    d.from    = $('#tkFrom').val() || '';
                    d.to      = $('#tkTo').val() || '';
                    d.state   = self.pickedStr('state');
                    d.type    = self.pickedStr('type');
                    d.keyword = $('#tkKwd').val() || '';
                },
            },
            columns: this.columns(),
            // 「전체」에는 닫힌 것이 섞인다 — 줄째로 톤을 낮춰 열린 일감과 눈으로 갈린다.
            // 줄 전체가 처리창의 과녁이다(is-handle) — 처리창이 없는 종류는 손가락이 뜨지 않는다
            // 종류 전용 목록은 소스 행이라 원장 상태로 흐리게 하지 않는다(판정 칸이 따로 말한다)
            createdRow: (tr, d) => {
                if (!view && d.state === 'done') tr.classList.add('is-done');
                if (!view && d.state === 'skip') tr.classList.add('is-skip');
                if (d.handler) tr.classList.add('is-handle');
            },
            language: {
                emptyTable: view ? '해당 조건의 건이 없습니다.' : '처리할 일감이 없습니다.', loadingRecords: '로딩 중...',
                zeroRecords: '일치하는 결과가 없습니다.', info: '_START_–_END_ / _TOTAL_건',
                infoEmpty: '0건', infoFiltered: '',
                paginate: { previous: "<i class='fa fa-chevron-left'></i>", next: "<i class='fa fa-chevron-right'></i>" },
            },
        });
    }

    /**
     * 칸 구성 — **앞(담당·처리)과 뒤(경과·⋯)는 늘 같고 가운데만 갈린다.**
     *
     *   「전체」      원장번호 · 종류 · 내용(제목 한 줄) · 회원 · 발생
     *   종류 하나     그 종류 전용 칸 (Tasks/Views.js — 값은 서버가 `detail` 로 붙인다)
     *
     * 담당을 앞에 두는 이유 — 목록에서 제일 먼저 묻는 것이 "이건 누가 보고 있나" 다.
     * 완료·제외만 볼 때는 같은 자리가 '누가 닫았나'(처리자) 를 말한다.
     */
    columns() {
        const self   = this;
        const closed = Tasks.isClosed(this.state());
        const view   = this.view();

        const who = closed
            ? { data: null, title: '처리자', className: 'text-center tk-nowrap', width: '120px',
                render: (d) => {
                    const w = d.done_by === 'system' ? '자동' : (d.done_name || '관리자');
                    return `<div>${self.esc(w)}</div><div class="tk-sub">${(d.done_at || '').slice(5, 16)}</div>`;
                } }
            : { data: null, title: '담당', className: 'text-center', width: '90px',
                render: (d) => d.assignee_name
                    ? `<span${d.assignee === self.me ? ' class="tk-mine"' : ''}>${self.esc(d.assignee_name)}</span>`
                    : '<span class="text-muted">-</span>' };

        // 머리글이 '처리' 인 이유 — 이 칸은 **알림을 어떻게 다루나**(공통 4단계)를 말한다.
        // 그 일이 도메인에서 어디까지 갔나(업무 단계)는 종류 전용 칸이 말한다
        const state = { data: null, title: '처리', className: 'text-center', width: '80px',
            render: (d) => self.stateCell(d) };

        const tail = [
            { data: null, title: '경과', className: 'text-center', width: '70px',
                render: (d) => {
                    const h = d.elapsed_h;
                    const t = h < 24 ? `${h}시간` : `${Math.floor(h / 24)}일`;
                    return d.overdue ? `<span class="tk-late">${t}</span>` : `<span class="text-muted">${t}</span>`;
                } },
            // 원장 쪽 손잡이(이력·빼기·다시 열기). 처리는 줄을 누르는 것이라 여기 두지 않는다
            { data: null, title: '', className: 'text-center', width: '36px',
                render: (d) => d.num ? '<button type="button" class="tk-more" data-tk-menu title="이력 · 목록에서 빼기">'
                    + '<i class="fas fa-ellipsis"></i></button>' : '' },
        ];

        // 원장번호(g5_admin_tasks.num) — 종류 전용 목록에서 원장에 안 오른 건은 번호가 없다
        const taskNum = { data: null, title: '원장번호', className: 'text-center tk-nowrap', width: '70px',
            render: (d) => d.num || '<span class="text-muted">-</span>' };

        if (view) {
            // 종류 전용 목록 — 원장번호 · 담당 · 알림 · (그 종류의 칸) · ⋯ . 경과는 원장 것이라 뺀다(날짜 칸이 따로 있다).
            // 담당칸은 옛 도메인 화면과 같다: 진행 중이면 보고 있는 사람, 끝났으면 처리한 사람
            const owner = { data: null, title: '담당', className: 'text-center', width: '80px',
                render: (d) => {
                    if (d.done_name) return `<span title="처리">${self.esc(d.done_name)}</span>`;
                    if (!d.assignee_name) return '<span class="text-muted">-</span>';
                    return `<span class="tk-mine" title="처리중">${self.esc(d.assignee_name)}</span>`;
                } };
            // 원장에 오르지 않은 건(알림 대상이 아닌 건)은 '-' — 이 칸은 알림의 처리 상태다
            const alarm = { data: null, title: '알림', className: 'text-center', width: '70px',
                render: (d) => d.state ? self.stateCell(d) : '<span class="text-muted">-</span>' };
            const mid = Views[view].columns(this, this.f).map((c) => ({
                data: null, title: c.title, className: c.className || '', width: c.width,
                render: (d) => c.render(d.detail || {}, d),
            }));
            return [taskNum, owner, alarm, ...mid, tail[1]];
        }

        return [
            taskNum,
            // 뱃지 색은 Provider 가 고른다(BadgeSource::HUE) — 화면이 종류를 알 필요가 없다
            { data: null, title: '종류', className: 'text-center', width: '110px',
                render: (d) => `<span class="tk-type tk-type--${self.hue(d.hue)}">${self.esc(d.label)}</span>` },
            who, state,
            // 제목은 종류마다 다른 말을 담는다 — 도메인 값은 종류를 고르면 칸으로 펼쳐진다
            { data: null, title: '내용',
                render: (d) => {
                    const pri = d.priority ? '<i class="fas fa-exclamation-circle tk-pri" title="급함"></i>' : '';
                    const re  = d.reopen_cnt ? `<div class="tk-sub">되살아남 ${d.reopen_cnt}회</div>` : '';
                    return `<span class="tk-title">${pri}${self.esc(d.title)}</span>${re}${self.memoLine(d)}`;
                } },
            // 회원 표기는 관리자 공용 규약을 그대로 쓴다 — `이름#번호` + 누르면 회원 팝오버
            { data: null, title: '회원', className: 'text-center', width: '130px',
                render: (d) => self.member(d.mb_no, d.mb_name) },
            // 발생시각의 뜻은 종류마다 다르다 — 소스가 생긴 때가 기본이고, 악덕 정정은
            // 정정이 올라온 날, 환원보류는 마지노선 15일 전(창 진입일)이다
            { data: 'opened_at', title: '발생', className: 'text-center tk-nowrap', width: '100px',
                render: (v) => self.when(v) },
            ...tail,
        ];
    }

    /* ── 칸 그리기 도우미 (Tasks/Views.js 도 빌려 쓴다) ─────────── */

    member(no, name, sido) {
        return $j.F.Admin.Member.Pop.cell(no, name, sido ? { sub: sido } : {});
    }

    /** 오더번호 — 누르면 오더핸들 팝업 (줄 클릭으로 번지지 않는다, bindActions) */
    order(n) {
        return n ? `<a href="javascript:;" data-tk-order="${this.esc(n)}">${this.esc(n)}</a>` : '-';
    }

    phone(v) {
        return v ? ($j.Common.Util.phoneNumber(v) || v) : '';
    }

    won(n) {
        return Number(n || 0).toLocaleString() + '원';
    }

    /** 일시 — 날짜 / 그 아래 시분 */
    when(v) {
        if (!v) return '<span class="text-muted">-</span>';
        const [ymd, hms] = String(v).split(' ');
        return `<div>${this.esc(ymd || '')}</div><div class="tk-sub">${this.esc((hms || '').slice(0, 5))}</div>`;
    }

    /** 원장 메모 한 줄 — 주인공 칸 밑에 붙는다 */
    memoLine(d) {
        return d.memo ? `<div class="tk-memo"><i class="far fa-comment-dots"></i> ${this.esc(d.memo)}</div>` : '';
    }

    /** 긴 글 칸 — 비었으면 원장 메모라도 보인다 */
    textCell(text, d) {
        return (text ? this.esc(text) : '<span class="text-muted">-</span>') + this.memoLine(d);
    }

    /** 팔레트에 있는 색이름만 통과시킨다 — 서버 값이 그대로 클래스가 되므로 */
    hue(name) {
        return Tasks.HUES.includes(name) ? name : 'slate';
    }

    stateCell(d) {
        // 맡은 사람 없이 외부 응답을 기다리는 건 — 신규지만 종이 울리지 않으니 말도 다르게 한다
        if (d.state === 'new' && d.waiting) {
            return '<span class="tk-state tk-wait" title="응답을 기다리는 중 — 종이 울리지 않습니다">대기</span>';
        }

        const cls = { new: 'tk-new', doing: 'tk-doing', done: 'tk-done', skip: 'tk-skip' }[d.state] || 'tk-done';
        const txt = Tasks.STATE_LABEL[d.state] || d.state;

        // '처리중' 은 사람이 맡았을 때만 생긴다(여는 순간 확인창이 묻는다) — 담당 없는 처리중은 없다.
        // 도메인이 어디까지 갔는지(검토중 등)는 원장이 옮겨 적지 않는다. 담당 화면이 아는 일이다.
        return `<span class="tk-state ${cls}">${txt}</span>`;
    }

    /**
     * 처리 메뉴 — 앵커 팝오버.
     *
     * 행마다 버튼을 다섯 개 늘어놓으니 표의 절반을 액션이 먹었다. 회원 팝오버와 같은 장치를
     * 써서($j.Ui.Tooltip) 점 세 개 하나로 접는다 — body 에 붙으므로 표의 overflow 에 안 잘리고
     * 같은 버튼을 다시 누르면 닫힌다.
     *
     * 팝오버가 body 로 옮겨가면 DOM 으로 행을 거슬러 올라갈 수 없다. 그래서 연 행을 들고 있는다
     * (회원 팝오버의 _lastRow 와 같은 방식).
     */
    openMenu(anchor, d) {
        this._menuRow = d;
        this._logs    = null;

        const closed = d.state === 'done' || d.state === 'skip';
        const rows   = [];

        // 이름은 '무엇을 하는지', 오른쪽 작은 글씨는 '그래서 어떻게 되는지' 다.
        //
        // **「내가 맡기」는 두지 않는다.** 맡을지는 여는 순간 확인창이 묻고(TaskGuard),
        // 열지도 않고 맡아두는 일은 실제로 없다 — 열어봐야 내 일인지 알기 때문이다.
        // 메뉴에 따로 두면 같은 결정을 두 자리에서 하게 된다.
        // 담당을 비우는 동작도 없다: 벌어지는 일은 "비우는 것" 이 아니라 "이어받는 것" 이다.
        //
        // 잘못 뺀 것을 되돌리는 길. 자동완료(done)에는 내지 않는다 —
        // 그건 소스가 닫은 것이라 여기서 열어도 다음 동기화가 도로 닫는다
        if (d.state === 'skip') {
            rows.push({ act: 'reopen', ic: 'fa-rotate-left', label: '다시 열기', sub: '신규로 되돌림' });
            rows.push({ sep: true });
        }

        // 처리창을 여는 길은 하나다. 맡을지는 **창이 뜰 때 묻는다**(TaskGuard) —
        // 메뉴에서 미리 갈라놓으면 고르는 순간에는 담당이 누군지도 모른 채 정해야 한다.
        //
        // **닫힌 건도 연다.** "무엇을 보고 그렇게 판정했나" 는 처리한 뒤에 더 자주 묻는 질문이고,
        // 그 답은 처리창에만 있다. 담당은 묻지 않는다 — 닫힌 건에 담당은 뜻이 없다(TaskGuard).
        //
        // 처리는 줄을 누르는 것이 기본이다. 메뉴에도 같은 길을 하나 둔다 — ⋯ 를 연 김에 바로 가게.
        // 「처리 화면으로 이동」은 없다: 처리는 이 화면에서 끝낸다. 처리창이 없는 종류만 예외로 보낸다
        if (d.handler) {
            rows.push({ act: 'handle', ic: 'fa-pen-to-square', label: '처리창 열기',
                        sub: closed ? '내용만 본다' : '맡을지 묻는다' });
        } else if (d.url) {
            rows.push({ act: 'open', ic: 'fa-up-right-from-square', label: '처리 화면으로 이동', sub: '새 탭' });
        }

        // **「목록에서 빼기」는 맨 아래.** 어쩌다 한 번 쓰는 것이라 자주 쓰는 길(열어보기·이동)
        // 위에 두면 그때마다 눈이 한 번 더 걸리고, 손이 미끄러지면 남의 일감이 목록에서 사라진다.
        // 구분선으로 갈라 '여기서부터는 성격이 다르다' 를 보인다
        if (!closed) {
            rows.push({ sep: true });
            rows.push({ act: 'skip', ic: 'fa-eye-slash', label: '목록에서 빼기', sub: '제외 탭으로', tone: 'danger' });
        }

        // 마크업·모양은 판톤 공용(.jb-menu) — 회원 액션 팝오버와 같은 판이다.
        // 머리줄(__h)은 두지 않는다 — 팝오버가 제목 바로 옆에 붙어 뜨므로 같은 말을 두 번 적는 셈이다
        const menu = rows.map((r) => r.sep
            ? '<hr>'
            : `<div class="jb-menu__i${r.tone ? ' is-' + r.tone : ''}" data-tk-act="${r.act}">`
              + `<span><i class="fas ${r.ic} jb-menu__ic"></i>${r.label}</span><em>${r.sub}</em></div>`).join('');

        // 이력은 오른쪽에 붙여 **고르기 전에 무슨 일이 있었는지 보게** 한다 —
        // 예전엔 따로 창을 띄워야 해서, 남이 손댄 건지 모른 채 누르는 일이 있었다
        $j.Ui.Tooltip.show(anchor, `
            <div class="tk-menu2">
                <div class="jb-menu">${menu}</div>
                <div class="tk-hist" id="tkHist">${this.histShell()}</div>
            </div>`,
            { tone: 'panel', maxWidth: 480 });

        this.loadLogs(d.num);
    }

    /**
     * 이력칸 껍데기 — **요약만** 보여준다.
     *
     * 예전엔 여기에 표를 통째로 넣었더니 팝오버가 넓어져, 정작 눌러야 할 메뉴가 앵커에서
     * 멀어졌다(마우스가 그만큼 더 움직인다). 여기서 답할 것은 "누가 손댔나" 한 가지면 되고,
     * 자세히 볼 일은 드무니 그때만 창을 연다.
     */
    histShell() {
        return `<div class="tk-hist__h">
                    <span><i class="fas fa-clock-rotate-left"></i> 처리 이력</span>
                    <button type="button" class="tk-hist__more" data-tk-act="logs">자세히 <i class="fas fa-chevron-right"></i></button>
                </div>
                <div id="tkHistBody"><div class="tk-hist__e">불러오는 중…</div></div>`;
    }

    async loadLogs(num) {
        const d = await $.post('/adm/ajax/tasks/logs', { num });
        this._logs = d.data || [];
        this.drawLogs();
    }

    /**
     * 최근 셋만 한 줄씩 — **시간 · 담당자 · 상태** 셋이면 "누가 손댔나" 가 답해진다.
     * 무엇을 했는지(한 일)·메모는 「자세히」가 맡는다.
     */
    drawLogs() {
        const all  = this._logs || [];
        const body = all.length
            ? all.slice(0, 3).map((l) => `
                <div class="tk-hist__i">
                    <span class="tk-hist__d">${this.esc(this.logTime(l.created_at))}</span>
                    <span class="tk-hist__w">${l.manage_name ? this.esc(l.manage_name) : '시스템'}</span>
                    <b>${this.esc(Tasks.STATE_LABEL[l.to_state] || l.to_state || '-')}</b>
                </div>`).join('')
              + (all.length > 3 ? `<div class="tk-hist__rest">외 ${all.length - 3}건</div>` : '')
            : '<div class="tk-hist__e">기록이 없습니다.</div>';

        $('#tkHistBody').html(body);
    }

    /**
     * 이력 시각 — **오늘이면 시분초, 아니면 날짜.**
     *
     * 오늘 벌어진 일은 순서가 중요하다(누가 먼저 손댔나) — 분까지만으로는 같은 분에 일어난
     * 두 기록이 구분되지 않는다. 지난 일은 초가 필요 없고 며칠 전인지가 궁금하다.
     */
    logTime(v) {
        const s = String(v || '');
        if (!s) return '-';

        return s.slice(0, 10) === this.ymd(new Date()) ? s.slice(11, 19) : s.slice(0, 10);
    }

    /**
     * 처리 이력 전체 — 칸을 갈라 적는다.
     *
     * 팝오버의 요약이 "누가 손댔나" 를 답한다면, 이 창은 **줄을 견주며 읽는** 자리다.
     * 한 줄로 뭉치면 무엇이 언제 누구에 의해 어떻게 바뀌었는지가 눈으로 안 갈린다.
     */
    async showLogs(num) {
        const d = await $.post('/adm/ajax/tasks/logs', { num });
        const list = d.data || [];

        const body = list.length
            ? list.map((l) => {
                const from = Tasks.STATE_LABEL[l.from_state] || l.from_state || '';
                const to   = Tasks.STATE_LABEL[l.to_state] || l.to_state || '';
                // 상태가 안 바뀐 기록(메모 등)은 화살표를 그리지 않는다
                const move = (from && to && from !== to)
                    ? `${from} <i class="fas fa-arrow-right tk-log__ar"></i> ${to}`
                    : (to || from || '<span class="text-muted">-</span>');

                return `<tr>
                    <td class="tk-log__t">${this.esc((l.created_at || '').slice(0, 16))}</td>
                    <td>${this.esc(this.actLabel(l.act))}</td>
                    <td class="tk-log__s">${move}</td>
                    <td>${l.manage_name ? this.esc(l.manage_name) : '<span class="text-muted">시스템</span>'}</td>
                    <td class="tk-log__m">${l.memo ? this.esc(l.memo) : '<span class="text-muted">-</span>'}</td>
                </tr>`;
            }).join('')
            : '<tr><td colspan="5" class="text-muted text-center p-3">기록이 없습니다.</td></tr>';

        // 팝오버를 살려둔 채 창을 연다 — 툴팁(1070)이 모달(1055)보다 위라 그냥 두면 창을 덮는다.
        // 백드롭 아래로 물렸다가 창이 닫히면 되돌린다
        const $tip = $('.jb-tip.is-open').addClass('is-under');

        $j.Ui.Modal.open({
            id: 'tk-logs', width: '700px', variant: 'admin', title: '처리 이력',
            html: `<table class="tk-log">
                <thead><tr><th>시각</th><th>한 일</th><th>처리 상태</th><th>사람</th><th>메모</th></tr></thead>
                <tbody>${body}</tbody>
            </table>`,
            onClose: () => $tip.removeClass('is-under'),
        });
    }

    bindActions() {
        // ⋯ → 원장 메뉴(이력·빼기). 행 데이터는 DataTable 에서 꺼낸다
        $('#tkRoot').on('click.tk', '[data-tk-menu]', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const d = this.$table.row($(e.currentTarget).closest('tr')).data();
            if (d) this.openMenu(e.currentTarget, d);
        });

        // 오더번호 → 오더핸들 팝업 (관리자 공용). 줄 클릭(처리창)으로 번지지 않게 끊는다
        $('#tkRoot').on('click.tk', '[data-tk-order]', (e) => {
            e.preventDefault();
            e.stopPropagation();
            $j.F.Admin.Util.openOrderHandle(Number($(e.currentTarget).data('tk-order')));
        });

        // 악덕 — 제보자 이름은 그 회원의 악덕알리미 모바일(대리로그인), 승인 상태는 악덕마스터 창
        $('#tkRoot').on('click.tk', '[data-tk-devilmb]', (e) => {
            e.preventDefault(); e.stopPropagation();
            $j.F.Admin.Util.devilMobile($(e.currentTarget).data('tk-devilmb'));
        });
        $('#tkRoot').on('click.tk', '[data-tk-dvmaster]', (e) => {
            e.preventDefault(); e.stopPropagation();
            $j.F.Admin.Devil.Case.openMaster(Number($(e.currentTarget).data('tk-dvmaster')));
        });

        // **줄 → 처리창.** 줄 전체가 과녁이다 — 전용 칸으로 펼치면 '제목' 이 따로 없어서 어디를
        // 눌러야 할지 찾게 된다. 줄 안의 링크·버튼(회원 팝오버·오더번호·⋯)은 제 일을 한다
        $('#tkRoot').on('click.tk', '#tkTable tbody tr', (e) => {
            if ($(e.target).closest('a, button, input, [data-mb-pop]').length) return;
            if (window.getSelection && String(window.getSelection()).length) return;   // 글자를 긁는 중

            const d = this.$table && this.$table.row(e.currentTarget).data();
            if (!d) return;
            if (d.handler) this.handleInPlace(d);
            else this.openSource(d);
        });

        // 팝오버는 body 에 붙으므로 위임은 document 에 건다 (회원 팝오버와 같은 방식)
        $(document).on('click.tkact', '.jb-tip [data-tk-act]', (e) => {
            const act = $(e.currentTarget).data('tk-act');
            const d   = this._menuRow;

            // 「자세히」는 읽으러 가는 것이라 고르던 자리를 닫지 않는다 — 창을 닫으면
            // 팝오버가 그대로 남아 이어서 고를 수 있다. 나머지는 고른 순간 볼일이 끝난다
            if (act !== 'logs') $j.Ui.Tooltip.hide();

            if (d) this.runAction(act, d);
        });
    }

    /** 팝오버에서 고른 것 하나를 실행한다 */
    runAction(act, d) {
        const num = d.num;

        switch (act) {
            case 'handle':  this.handleInPlace(d); break;
            case 'open':    this.openSource(d); break;
            case 'logs':    this.showLogs(d.num); break;
            case 'skip':    this.askSkip(d); break;
            case 'reopen':  this.post('/adm/ajax/tasks/reopen', { num }); break;
        }
    }

    /**
     * 처리 화면으로 이동 — **처리창이 없는 종류만** 탄다(지금 원장형은 전부 처리창이 있다).
     * 주소는 목록이 아니라 **그 건**을 가리킨다
     * (`LedgerProvider::itemUrl` → `?open=<ref_id>`).
     *
     * **담당은 여는 쪽이 묻는다.** 모달이 있는 종류(`handler`)는 도착한 화면에서 그 창이
     * 뜨면서 `TaskGuard` 가 묻는다 — 여기서 또 물으면 두 번 묻는 셈이다. 모달이 없는
     * 종류(환원보류→접수목록)만 목적지에 물어줄 창이 없어서 여기서 대신 묻는다.
     */
    async openSource(d) {
        if (!d.url) return;
        if (!d.handler && !await $j.F.Admin.TaskGuard.check(d.type, d.ref_id)) return;

        window.open(d.url, '_blank');
        this.reload();
    }

    /**
     * 그 자리에서 연다 — 종류가 선언한 모달 (`BadgeSource::HANDLER`).
     *
     * 맡을지는 여기서 정하지 않는다 — 창이 뜰 때 `TaskGuard` 가 원장을 보고 묻는다.
     * 도메인 화면에서 연 경우와 같은 물음이어야 해서 그쪽 한 곳에 두었다.
     *
     *   'Collusion.Case@open'  →  $j.F.Admin.Collusion.Case.open(refId)
     *
     * 모달이 처리를 끝내면 그 한 건만 소스와 다시 맞추고 줄을 새로 받는다 — 전량 동기화를
     * 돌릴 이유가 없다. 모듈은 `F/Admin/` 에 있어야 한다(Pages/ 에 있으면 그 화면 것이다).
     */
    async handleInPlace(d) {
        // 담당 확인·자동 맡기는 **모달이 한다** — 도메인 화면에서 열 때도 같아야 하므로
        // 그쪽 한 곳에 두었다. 여기서 또 물으면 두 번 묻는다
        const [path, method] = String(d.handler || '').split('@');
        const mod = (path || '').split('.').reduce((o, k) => (o || {})[k], $j.F.Admin);

        if (!mod || typeof mod[method] !== 'function') {
            $j.Ui.Toast.show('이 종류는 여기서 처리할 수 없습니다.', { type: 'warn' });
            return;
        }

        // 처리 결과를 받아 그 줄만 갱신한다. 모듈마다 config 를 한 번씩만 받도록 표시해둔다
        if (!this._wired) this._wired = {};
        if (!this._wired[d.handler] && typeof mod.config === 'function') {
            mod.config({ onChanged: () => this.resyncOne(this._handledNum) });
            this._wired[d.handler] = true;
        }
        this._handledNum = d.num;

        // **끝날 때까지 기다린다.** open() 은 창을 그리기 전에 `TaskGuard` 로 담당을 묻는데,
        // 사람이 그 확인창을 읽는 동안에도 시계는 간다 — 예전엔 400ms 뒤에 목록을 다시
        // 받았고, 그 시점엔 아직 「내가 맡기」를 누르기도 전이라 담당이 빈 채로 그려졌다.
        await mod[method](d.ref_id);

        // 여기까지 왔으면 담당 확인이 끝났다(맡았거나, 넘겨받았거나, 보기만 하거나)
        this.reload();
    }

    /** 모달이 소스를 바꿨다 — 그 한 건만 대조하고 목록·요약을 다시 받는다 */
    async resyncOne(num) {
        if (num) await $.post('/adm/ajax/tasks/resync', { num });
        this.reload();
    }

    /**
     * 목록에서 빼기 — 사유는 **선택**이다. 대개 "중복" 한 마디라 필수로 걸면 그 한 마디를
     * 적게 하려고 창을 한 번 더 보게 만든다. 안 적으면 이력에 누가·언제만 남는다.
     *
     * **남이 맡은 건이면 그 사실을 먼저 보인다** — 빼는 것은 되돌릴 수 있지만, 남이 보던
     * 일감이 목록에서 사라지는 것은 그 사람에게 통보 없이 일어난다.
     *
     * `Dialog.prompt` 대신 `Dialog.open` 에 입력칸을 직접 넣는다 — prompt 의 textarea 는
     * `rows=6` 으로 박혀 있어 한 마디 적을 자리에 여섯 줄짜리 상자가 뜬다.
     * 폭도 잡아준다: 창은 width:auto 라 안내문 한 줄이 길면 화면 끝까지 늘어난다.
     */
    async askSkip(d) {
        const num   = d.num;
        const other = d.assignee && d.assignee !== this.me ? d.assignee_name : '';
        const id    = 'tk-skip-' + num;
        let memo = '';

        const ok = await $j.Ui.Dialog.open({
            tone:     'danger',
            maxWidth: 360,
            title:    '목록에서 빼기',
            desc:     '「제외」 탭으로 옮깁니다.',
            // 남의 일감일 때만 한 줄 선다. 입력칸보다 위여서 htmlAfter 를 쓴다
            notes:     other ? [`${other} 님이 맡은 건입니다.`] : null,
            htmlAfter: `<textarea id="${id}" class="ui-dlg-input" rows="2"
                                  placeholder="사유 (선택)"></textarea>`,
            confirm:   '빼기',
            cancel:    '취소',
            onConfirm: () => { memo = $('#' + id).val(); },
            onOpen:    () => { const el = document.getElementById(id); if (el) el.focus(); },
        });
        if (!ok) return;

        this.post('/adm/ajax/tasks/skip', { num, memo });
    }

    actLabel(act) {
        return {
            open: '접수', claim: '맡음', state: '상태변경',   // 옛 'release'(담당비움) 기록이 남아 있을 수 있다
            memo: '메모', reopen: '되살아남', auto_close: '자동완료',
        }[act] || act;
    }

    async post(url, data) {
        const d = await $.post(url, data);
        $j.Ui.Toast.show(d.message || '', { type: d.result ? 'success' : 'warn' });
        if (d.result) { this.reload(); }
    }

    tomorrow() {
        const t = new Date();
        t.setDate(t.getDate() + 1);
        return t.toISOString().slice(0, 10);
    }

    esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, (c) =>
            ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    }
}
